import React from 'react'
import Tilt from 'react-parallax-tilt'
import { BuildProjectLabels } from 'src/types'
import { useAnimation } from 'src/hook'
import { OverCard } from './styles'
import { Refer } from '../styles'
import { OverCardComponent } from './overCardComponent'

export interface Props {
    value: boolean
    data: BuildProjectLabels
}

export const MapSection = ({ data, value }: Props) => {
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    return (
        <Tilt>
            <Refer ref={ref}>
                {value && (
                    <OverCard
                        background={data.background}
                        address={data.address}
                        paddingLeft={'xxmedium'}
                        paddingRight={'xxmedium'}
                        animate={control}
                        variants={data.animation}
                        paddingTop={[0, 0, 0, 'xxxsmall']}
                        paddingBottom={[0, 0, 0, 'xxxsmall']}
                    >
                        <OverCardComponent {...data} />
                    </OverCard>
                )}
                {!value && (
                    <OverCard
                        background={data.background}
                        address={data.address}
                        paddingLeft={'xxmedium'}
                        paddingRight={'xxmedium'}
                        variants={data.animation}
                        paddingTop={[0, 0, 0, 'xxxsmall']}
                        paddingBottom={[0, 0, 0, 'xxxsmall']}
                    >
                        <OverCardComponent {...data} />
                    </OverCard>
                )}
            </Refer>
        </Tilt>
    )
}
